var map = {
	"./lunchly_menu1.png": "8067",
	"./lunchly_menu2.png": "ab6a",
	"./lunchly_menu3.png": "7147",
	"./lunchly_menu4.png": "0201",
	"./lunchly_menu5.png": "e3a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9726";